/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Term/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaIconSearch from 'DesignSystem/Svgs/TysiaIconSearch/index'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Term({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/ReferralsSection/Add/Content/Templates/Content/Referral/Value/Search/Professional/Term",
  onMouseEnter,
  onMouseLeave,
  hovered
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({onMouseEnter,onMouseLeave})
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let newReferralPersonValueValueData = fromData.useDataValue({ viewPath,
context: 'new_referral',
path: 'person_value',
})
let newReferralSubmittedValueData = fromData.useDataValue({ viewPath,
context: 'new_referral',
path: 'submitted',
})
let aggregateData = fromHelpers.checkIfValid(newReferralPersonValueValueData, newReferralSubmittedValueData)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtTysiainputcontentBordercolorPrimaryInvalid = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.borderColor.primary.invalid'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let newReferralPersonValueValueData1 = fromData.useDataValue({ viewPath,
context: 'new_referral',
path: 'person_value',
})
let constantData = 'Search...'
let aggregateData1 = fromAggregate.getValueOrDefault(newReferralPersonValueValueData1, constantData)
  return (<React.Fragment
>
<div
  data-testid="Term.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Term.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaSelectLabel
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Professiona"
/>
<button
  data-testid="Term.Horizontal:1"
  data-view-path={viewPath}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../Search/Content'))}
 {...isHoveredBind}
 style={{'--bblr-2-bszy': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-3-bszy': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-4-bszy': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-5-bszy': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-6-bszy': aggregateData ? dtTysiainputcontentBordercolorPrimaryInvalid : dtColorsNeutral400,'--bc-1-bszy': hovered ? dtColorsNeutral300 : "transparent"}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaIconSearch
  viewPath={`${viewPath}/TysiaIconSearch`}
 width={dtSpaceS}
 height={dtSpaceS}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXs}
 size="large"
 data="new_referral.person_value"
 data="'Search...'"
 aggregate="/Data/aggregate.js getValueOrDefault"
 text={aggregateData1}
/>
</button>
</div>
</div>
{children}
</React.Fragment>)
}